<template>
  <div v-if="messageHistory">
    <button @click="cleanMessageHistory" v-if="messageHistory.length">
      Dismiss All
    </button>
    <table>
      <Message
        v-for="(message, index) in messageHistory"
        :key="index"
        :message="message"
      />
    </table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Message from '@/components/Message.vue'

export default {
  name: 'MessageList',
  computed: mapState(['messageHistory']),
  methods: mapMutations(['cleanMessageHistory']),
  components: {
    Message
  }
}
</script>

<style scoped>
table {
  width: 100%;
}
</style>
